export default "__VITE_ASSET__BKwXeBGQ__"